<!-- 
This file refers to GDO-Product-Container 
Do not write any logic here!

    ## Module_Structure ##
    Gdo Desktop:
        -> Gdo Product:
        -- -> Gdo Product Container:
        --- -> Gdo Product Component:
        --- -- -> Gdo product Card (All other components should be at this level)
-->
<router-outlet></router-outlet>